import api from '../api/axios.config';

export const promoService = {
  getPromoCalendar: async (filters) => {
    try {
      const response = await api.get(`/promo-calendar/`, {
        params: filters,
      });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  },
};
